import actors from './actors'
import frequencies from './frequencies'
import paymentsStates from './payments-states'
import persons from './persons'
import periods from './periods'
import salesStates from './sales-states'
import subscriptionStates from './subscriptions-states'
import typesOfShopp from './types-of-shopp'

const parameters = {
  actors: [...actors],
  frequencies: [...frequencies],
  paymentsStates: [...paymentsStates],
  periods: [...periods],
  persons: [...persons],
  salesStates: [...salesStates],
  subscriptionStates: [...subscriptionStates],
  typesOfShopp: [...typesOfShopp]
}

export default parameters
